var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogsSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3905 16.4246C12.8698 15.9039 12.8698 15.0597 13.3905 14.539C13.9112 14.0183 14.7554 14.0183 15.2761 14.539L20.6095 19.8723C21.1302 20.393 21.1302 21.2372 20.6095 21.7579C20.0888 22.2786 19.2446 22.2786 18.7239 21.7579L13.3905 16.4246Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.18301C0 14.2547 4.11138 18.366 9.18302 18.366C14.2547 18.366 18.366 14.2547 18.366 9.18301C18.366 4.11138 14.2547 0 9.18302 0C4.11138 0 0 4.11138 0 9.18301ZM15.7358 9.1843C15.7358 12.8069 12.7991 15.7436 9.17649 15.7436C5.55388 15.7436 2.61719 12.8069 2.61719 9.1843C2.61719 5.5617 5.55388 2.625 9.17649 2.625C12.7991 2.625 15.7358 5.5617 15.7358 9.1843Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogsSearchIcon);
export default __webpack_public_path__ + "static/media/logsSearchIcon.27641b3028e0c8e6b6637f5e0454e110.svg";
export { ForwardRef as ReactComponent };